import { useCallback } from 'react'

import { useRouter as usePagesRouter } from 'next/compat/router'
import { useRouter, useSearchParams } from 'next/navigation'

const SAVED_SEARCH_PARAM = 'savedSearchId'

export const deleteSavedSearchId = (
  params: URLSearchParams
): URLSearchParams => {
  params.delete(SAVED_SEARCH_PARAM)
  return params
}

const useSavedSearchId = () => {
  const pagesRouter = usePagesRouter()
  const router = useRouter()
  const searchParams = useSearchParams()
  const savedSearchId = searchParams?.get(SAVED_SEARCH_PARAM) ?? null

  const setSavedSearchId = useCallback(
    (id?: string) => {
      if (pagesRouter) {
        console.warn(
          'setSavedSearchId called in a pagesRouter context - this is not expected'
        )
        return
      }
      const params = new URLSearchParams(searchParams?.toString() || '')

      if (!id) {
        params.delete(SAVED_SEARCH_PARAM)
      } else {
        params.set(SAVED_SEARCH_PARAM, id)
      }

      router.push(`?${params.toString()}`, { scroll: false })
    },
    [pagesRouter, router, searchParams]
  )

  return { savedSearchId, setSavedSearchId }
}

export default useSavedSearchId
